import COM from './utils/common';

var utils = {...COM};
export default utils;

//购物车的相关
import menu from './utils/menu';
export const MENU = menu;

//门店的相关
import store from './utils/store.js';
export const STORE = store;
// 检查是否是灰度环境，当灰度环境时（域名中有 /new/）
export const isGrayEnvironment = () => {
  if (window.location.pathname.indexOf('/new/') == 0) {
    return true;
  }
  return false;
}

// 切换版本（灰度<->正式）
export const changeEnvironment = () => {
  if (window.location.pathname.indexOf('/new/') == 0) {
    let temp = window.location.origin + window.location.pathname;
    window.location.href = window.location.href.replace(temp, temp.replace('/new', ''));
  } else {
    let temp = window.location.origin + window.location.pathname;
    window.location.href = window.location.href.replace(temp, window.location.origin + '/new' + window.location.pathname);
  }
}



// WEBPACK FOOTER //
// ./../../plugins/util.js